import React, { useEffect, useRef, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import "./navbar.scss";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import './navbar.scss';

const Navbar = () => {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState("");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <section className='main_navbar'>
        <div className="custom-container">
          <div className='inner_navbar'>
            <img src='\assets\logo.svg' />
            <div className='middle_side'>
              <HashLink to="/#home" className={activeSection === "home" ? "active" : ""}>Home</HashLink>
              <HashLink to="/#about" className={activeSection === "about" ? "active" : ""}>About</HashLink>
              <HashLink to="/#overview" className={activeSection === "overview" ? "active" : ""}>Overview</HashLink>
              <HashLink to="/#howitswork" className={activeSection === "howitswork" ? "active" : ""}>How it works</HashLink>
              <HashLink to="/#benefits" className={activeSection === "benefits" ? "active" : ""}>Benefits</HashLink>
            </div>
            <button>Get Started <img src='\assets\buttonn.svg' /></button>
          </div>
        </div>

      </section>
      <div className='phone_navbar'>
        <div className='inner_phone'>
          <img src='\assets\logo.svg' />
          <img src='\assets\phonetool.svg' onClick={handleShow} />
        </div>
      </div>
      <Offcanvas show={show} onHide={handleClose} className="navbar">
        <Offcanvas.Header>
          <Offcanvas.Title>
            <div className="navsidebar">
              <Link to="/"><img src="/assets/logo.svg" onClick={handleClose} />
              </Link>

              <img src="\assets\cross.svg" onClick={handleClose} />
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="linkssside">
            <HashLink onClick={handleClose} to="/#home" className={activeSection === "whychooseus" ? "active" : ""}>Home</HashLink>
            <HashLink onClick={handleClose} to="/#about" className={activeSection === "whychooseus" ? "active" : ""}>About</HashLink>
            <HashLink onClick={handleClose} to="/#overview" className={activeSection === "whychooseus" ? "active" : ""}>Overview</HashLink>
            <HashLink onClick={handleClose} to="/#howitswork" className={activeSection === "whychooseus" ? "active" : ""}>How it works</HashLink>
            <HashLink onClick={handleClose} to="/#benefits" className={activeSection === "whychooseus" ? "active" : ""}>Benefits</HashLink>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default Navbar
